import { TradingClassification } from '../../types';
import { atomWithBroadcast } from './atomWithBroadcast';

export const tradingClassificationAtom = atomWithBroadcast<TradingClassification | undefined>(
  'core/tradingClassification',
  undefined,
);
